import { Alert, Button, Modal, Tooltip, Typography } from "antd"
import { QRCodeSVG } from "qrcode.react"
import { useCallback, useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard"
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import NoData from "src/components/shared/noDataComponent";
const { Text } = Typography;
const DepositCode = (props) => {
    const [walletAddress, setWalletAddress] = useState()
    const [loader, setLoader] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    useEffect(() => {
        if (props?.WalletData?.id) {
            getWalletAddress(props?.WalletData?.id)
        }
    }, [props?.WalletData])
    const getWalletAddress = async (walletId) => {
        setLoader(true)
        const response = await apiCalls.walletAddress(walletId)
        if (response.ok) {
            setWalletAddress(response.data)
            setLoader(false)
            setErrorMessage(null)
        }
        else {
            setWalletAddress(null)
            setLoader(false)
            setErrorMessage(apiCalls.isErrorDispaly(response))
        }
    }
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    return (
        <Modal
            open={props.open}
            onCancel={props.closeModel}
            title={'Deposit'}
            maskClosable={false}
            closeIcon={
                <Tooltip title="Close">
                    <span className="icon close c-pointer" />
                </Tooltip>
            }
            footer={<Button
                type="primary"
                className="cancel-btn"
                onClick={props.closeModel}
            >
                Close
            </Button>
            }>
            {loader && <div className="text-center"><Loader /></div>}
            {errorMessage !== null && (
                <Alert
                    className='mb-6'
                    type="error"
                    description={errorMessage}
                    onClose={closeError}
                    showIcon
                    closable
                />
            )}
            {!loader && <>{walletAddress && <>
                <div className='mb-4 text-center  pt-4'>
                    <p className="mb-1.5 text-subTextColor font-semibold text-base">{walletAddress?.code} {walletAddress?.network ? `(${walletAddress?.network})` : ''}</p>
                    <QRCodeSVG value={walletAddress?.address} className="qr-image mx-auto w-52 h-52" />
                </div>
                {walletAddress?.address && <div className='mb-4 text-center px-20'>
                    <CopyToClipboard text={walletAddress?.address} value={walletAddress?.address} options={{ format: 'text/plain' }}><Text copyable={{ tooltips: ['Copy', 'Copied'] }} className="text-whiteText ms-2">{walletAddress?.address || ''}</Text></CopyToClipboard>
                </div>}</>}
                {!walletAddress && <div className="wallet-nodata">
                    <NoData text={"No  Address  Available"} /></div>}</>}
        </Modal>
    )
}
export default DepositCode